import { createApp } from 'vue'
import App from './App.vue'

const app = createApp(App)

// 添加全局错误处理
app.config.errorHandler = (err, vm, info) => {
  console.error('Vue全局错误:', err);
  console.log('错误信息:', info);
}

app.mount('#app')
